import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";
import { ENDPOINTS } from "../../js/api/_config";
import OperatingHours from "./operatinghours";
import Header from "../common/header/Header";
import SecondaryButton from "../common/buttons/SecondaryButton";
import TagInput from "./input-tags";

import { Toast } from "../common/toast/toast";
import { BackButton } from "../common/back-button/back-button";
import { useDispatch, useSelector } from "react-redux";
import { getCountryStateInformation } from "../../reducer/slices/country-state/get-country-info-slice";
import { IconTimer } from "../../assets/icons/icon-timer";
import GetOpHours from "./read-operating-hours";
import AddEditHeader from "../common/add-edit-header/AddEditHeader";
import { CloseIcon } from "../../assets/icons/close-icon-simple";

const EditClinic = ({
  id,
  data,
  setIsViewLocation,
  setIsAddLocation,
  setOpenClinicSidebar,
}) => {
  let currentTimezone;
  const defaultHours = [
    { day: "Monday", checked: true, from: "08:00", to: "17:00" },
    { day: "Tuesday", checked: true, from: "08:00", to: "17:00" },
    { day: "Wednesday", checked: true, from: "08:00", to: "17:00" },
    { day: "Thursday", checked: true, from: "08:00", to: "17:00" },
    { day: "Friday", checked: true, from: "08:00", to: "17:00" },
    { day: "Saturday", checked: false, from: "", to: "" },
    { day: "Sunday", checked: false, from: "", to: "" },
  ];
  const [city, setCity] = useState("");
  const [postal, setPostal] = useState("");
  const [organizationName, setOrganizationName] = useState();
  const [selectedTimeZoneName, setSelectedTimeZoneName] = useState("");
  const [selectedCountryId, setSelectedCountryId] = useState("");
  const [selectedStateId, setSelectedStateId] = useState("");
  const [selectStateName, setSelectStateName] = useState("");
  const timezoneData = useSelector((state) => state.time_zone.data);
  const [addName, setAddName] = useState("");
  const [addPhoneNumber, setAddPhoneNumber] = useState("");
  const [addPrincipalInvestigator, setAddPrincipalInvestigator] = useState("");
  const [addAddress, setAddAddress] = useState("");
  const [addDisease, setAddDisease] = useState([]);
  const [clinicById, setClinicById] = useState([]);
  const [operatingHours, setoperatingHours] = useState(defaultHours);
  const [getDataOp, setgetDataOp] = useState([]);
  const [inputResponse, setInputResponse] = useState();
  const [toasts, setToasts] = useState([]);
  const [selectedName, setSelectedName] = useState(data.timezone || "");
  const [errors, setErrors] = useState({});
  const [tags, setTags] = useState([]);
  const [selectCountry, setSelectCountry] = useState("");
  const [stateList, setStateList] = useState();
  const [prevData, setPrevData] = useState();

  const [isEditLocation, setIsEditLocation] = useState(true);
  const countryData = useSelector((state) => state.country.countryData);

  const dispatch = useDispatch();
  const handleSelectCountryChange = (e) => {
    const selectedName = e.target.value; // Get the selected timezone
    setSelectCountry(selectedName);
    const selectedTimeZone = countryData.find(
      (tz) => tz.countryName === selectedName
    );
    if (selectedTimeZone && selectedTimeZone.countryID) {
      setSelectedCountryId(selectedTimeZone.countryID);
    }
    if (
      selectedTimeZone &&
      selectedTimeZone.stateResponseModel &&
      selectedTimeZone.stateResponseModel.length
    ) {
      setStateList(selectedTimeZone.stateResponseModel);
    }
  };
  const addToast = (message, type) => {
    const id = Date.now();
    setToasts([...toasts, { id, message, type }]);
    setTimeout(() => removeToast(id), 3000);
  };

  const removeToast = (id) => {
    setToasts(toasts.filter((toast) => toast.id !== id));
  };

  function convertToDiseaseNames(data) {
    return data.map((item) => item.diseaseName);
  }

  function convertSchedule(data) {
    // Filter only the checked days with valid time ranges
    const activeDays = data.filter(
      (item) => item.isChecked && item.time.from && item.time.to
    );
    if (activeDays.length === 0) return "";

    // Combine consecutive days with the same time range
    let result = [];
    let currentGroup = { days: [], time: "" };

    activeDays.forEach((item, index) => {
      const timeRange = `${item.time.from} - ${item.time.to}`;

      if (currentGroup.days.length === 0 || currentGroup.time === timeRange) {
        // Add the day to the current group
        currentGroup.days.push(item.day);
        currentGroup.time = timeRange;
      } else {
        // Push the current group and start a new one
        result.push(currentGroup);
        currentGroup = { days: [item.day], time: timeRange };
      }

      // Add the last group at the end
      if (index === activeDays.length - 1) {
        result.push(currentGroup);
      }
    });

    // Format the result
    return result
      .map((group) => {
        const dayRange =
          group.days.length > 1
            ? `${group.days[0]} to ${group.days[group.days.length - 1]}`
            : group.days[0];
        return `${dayRange} ${group.time}`;
      })
      .join(", ");
  }

    function setPrevDataFunc(prevData) {
        setAddName(prevData.name)
        setAddPhoneNumber(prevData.phoneNumber)
        setAddPrincipalInvestigator(prevData.principalInvestigator)
        setAddAddress(prevData.address)
        setTimeout(() => {
            setoperatingHours(prevData.operatingHoursJson)
        }, 3000)
        setgetDataOp(prevData.operatingHoursJson)
        setCity(prevData.city)
        setPostal(prevData.zip)
        setSelectedStateId(prevData.stateID)
        setSelectedCountryId(prevData.countryID)
        setSelectStateName(prevData.stateName)
        setSelectedCountryId(prevData.countryID)
        setSelectCountry(prevData.countryName)
        setSelectedTimeZoneName(prevData.timezone.displayName)
        setSelectedTimeZoneId(prevData.timezone.timezoneID)

        handleSelectCountryChange({ target: { value: prevData.countryName } })
        handleSelectStateChange({ target: { value: prevData.stateName } })
        if (prevData.disease) {
            const disease = convertToDiseaseNames(prevData.disease);
            setAddDisease(disease)
            setTags(disease)
        }
        if (prevData.operatingHoursJson) {
            // const string = convertSchedule(prevData.operatingHoursJson);
            // setInputResponse(string)

      const operatingHoursString = GetOpHours({
        operatingHours: prevData.operatingHoursJson,
      });
      setInputResponse(operatingHoursString);
    }
  }

  const handleSelectTimeZoneChange = (e) => {
    const selectedName = e.target.value; // Get the selected timezone
    setSelectedTimeZoneName(selectedName);
    const selectedTimeZone = timezoneData.find(
      (tz) => tz.displayName === selectedName
    );
    setSelectedTimeZoneId(selectedTimeZone.timezoneID);
  };

    const fetchClinicbyID = async () => {
        axios.get(`${ENDPOINTS.CLINIC.GET_CLINIC_BY_ID}?clinicInfoId=${id}`)
            .then(
                (res) => {

        const prevData = res.data.data;
        setPrevData(prevData);
        setPrevDataFunc(prevData);

                }
            )
    }

    useEffect(() => {
        dispatch(getCountryStateInformation());
    }, [])


  useEffect(() => {
    if (prevData) {
      handleSelectCountryChange({ target: { value: prevData.countryName } });
      handleSelectStateChange({ target: { value: prevData.stateName } });
    }
  }, [countryData]);

  const [isOpen, setIsOpen] = useState(false);

  const addOperatingHours = () => {
    setIsOpen(!isOpen);
  };

  // timezone ------------------------------------------------------------------------
  const [defaultSelectedTimezoneID, setdefaultSelectedTimezoneID] =
    useState("");
  const [getTimezone, setGetTimezone] = useState();
  const [selectedTimeZoneId, setSelectedTimeZoneId] = useState(
    defaultSelectedTimezoneID || ""
  );

    const fetchTimezone = async () => {
        const response = await axios.get(ENDPOINTS.CLINIC.TIMEZONE)

        setGetTimezone(response.data.data)
        currentTimezone = response.data.data.find((tz) => tz.displayName === data.timezone)

        setdefaultSelectedTimezoneID(currentTimezone.timezoneID)

    }

  const handleSelectChange = (e) => {
    setSelectedName(e.target.value); // Get the selected timezone
    const selectedTimeZone = getTimezone.find(
      (tz) => tz.displayName === selectedName
    );

    setSelectedTimeZoneId(selectedTimeZone.timezoneID);
  };

  // timezone ENDS------------------------------------------------------------------------


    const [popup, setPopup] = useState({ show: false, message: "", isError: false });
    const closePopup = () => {
        setIsOpen(false);
        setPopup({ show: false, message: "", isError: false });
    };
    function getCountryAndStateId(data, stateName) {
        // Validate input data
        if (!Array.isArray(data) || data.length === 0) {
          console.error("Invalid data: Data should be a non-empty array.");
          return null;
        }
      
        // Validate stateName
        if (typeof stateName !== "string" || stateName.trim() === "") {
          console.error("Invalid stateName: State name must be a non-empty string.");
          return null;
        }
      
        // Search for the state and country
        for (const country of data) {
          if (country.stateResponseModel && Array.isArray(country.stateResponseModel)) {
            const state = country.stateResponseModel.find(
              (state) =>
                typeof state.stateName === "string" &&
                state.stateName.toLowerCase() === stateName.toLowerCase()
            );
            if (state) {
              return {
                countryID: country.countryID,
                stateID: state.stateID,
              };
            }
          } else {
            console.warn(`Invalid stateResponseModel for countryID: ${country.countryID}`);
          }
        }
      
        console.warn("State not found!");
        return null; // Return null if no matching state is found
      }


    useEffect(() => {
        fetchClinicbyID()
        setSelectedTimeZoneId(defaultSelectedTimezoneID)
        dispatch(getCountryStateInformation({}));
        fetchTimezone()
    }, [])


    const validateForm = () => {
        const errors = {};
    
        // Validate Location Name
        if (!addName.trim()) {
            errors.name = "Location Name is required.";
        }
    
        // Validate Phone Number
        const phoneNumberPattern = /^[0-9]{10}$/; // Assuming 10-digit phone number
        if (!addPhoneNumber.trim()) {
            errors.phoneNumber = "Phone Number is required.";
        } else if (!phoneNumberPattern.test(addPhoneNumber)) {
            errors.phoneNumber = "Please enter a valid 10-digit phone number.";
        }
    
        // Validate Principal Investigator
        if (!addPrincipalInvestigator.trim()) {
            errors.principalInvestigator = "Principal Investigator is required.";
        }
    
        // // Validate Organization Name
        // if (!organizationName.trim()) {
        //     errors.organizationName = "Organization Name is required.";
        // }
    
        // Validate Time Zone
        if (!selectedTimeZoneName) {
            errors.timezone = "Time Zone is required.";
        }
    
        // Validate Operating Hours
        if (!inputResponse.trim()) {
            errors.operatingHours = "Operating Hours are required.";
        }
    
        // Validate Address
        if (!addAddress.trim()) {
            errors.address = "Address is required.";
        }
    
        // Validate Country
        if (!selectCountry) {
            errors.country = "Country/Region is required.";
        }
    
        // Validate State
        if (!selectStateName) {
            errors.state = "State is required.";
        }
    
        // Validate City
        if (!city.trim()) {
            errors.city = "City is required.";
        }
    
        // Validate Zip Code
        const postalCodePattern = /^[0-9]{5,6}$/; // Adjust as needed for postal code format
        if (!postal.trim()) {
            errors.postal = "Zip Code is required.";
        } else if (!postalCodePattern.test(postal)) {
            errors.postal = "Please enter a valid Zip Code.";
        }
    
        setErrors(errors);
        return Object.keys(errors).length === 0;
    };
    const handleSelectStateChange = (e) => {
        const selectedName = e.target.value; // Get the selected timezone
        setSelectStateName(selectedName)
        if(countryData && countryData.length){
            const stateAndCountryId = getCountryAndStateId(countryData, selectedName)
            if(stateAndCountryId && stateAndCountryId.countryID){
                setSelectedCountryId(stateAndCountryId.countryID)
                setSelectedStateId(stateAndCountryId.stateID)
            }
        }
       
       
        // setSelectedTimeZoneName(selectedName)
        // const selectedTimeZone = timezoneData.find((tz) => tz.displayName === selectedName);
        // setSelectedTimeZoneId(selectedTimeZone.timezoneID)
    };

    const handleEditClinic = async (e) => {
        e.preventDefault()
        if (!validateForm()) return;
        const responseBody = {
            "clinicalInfoID": id,
            "name": addName,
            "phoneNumber": addPhoneNumber,
            "principalInvestigator": addPrincipalInvestigator,
            "address": addAddress,
            "timezoneID": selectedTimeZoneId ? selectedTimeZoneId : defaultSelectedTimezoneID,
            "operatingHoursJson": getDataOp,
            "operatingHours": "",
            "city": city,
            "zip": postal,
            "countryID": selectedCountryId,
            "stateID": selectedStateId,
        }
        try {
            const response = await axios.put(ENDPOINTS.CLINIC.EDIT_CLINIC, responseBody);

            addToast("Location has been updated successfully.", "success")
            // setPopup({ show: true, message: "The Clinic details has been updated successfully!", isError: false });

        } catch (error) {

            addToast(error.message, "error")
            // console.error("Error updating data:", error.message);
            // setPopup({ show: true, message: error, isError: true });
        }
    };

  return (
    <>
      <div
        className="border-b border-[#B2ACC9] w-full header_sub"
        style={{ borderColor: "rgb(200, 214, 230)" }}
      >
        <div className="flex justify-between items-center w-full px-5 py-6">
          <h2 className="font-semibold text-left">{isEditLocation ? "Location Details" : "Edit Location"}</h2>
          <button onClick={() => setIsAddLocation(false)}>
            <CloseIcon />{" "}
          </button>
        </div>
      </div>
      <div className="main-body  p-8 h-[calc(100vh_-_320px)] w-[570px] overflow-auto scroll-m-0">
        <div className="w-full  grid gap-4">
          <div>
            <label for="clinicName" class="block form_label_color pb-4">
              Location Name <span className="aestrick_color">*</span>
            </label>
            <input
              type="text"
              name="name"
              className=" border_color border text-sm rounded-lg block w-full p-2.5 h-12"
              required
              disabled={isEditLocation}
              // placeholder="Your First Name"
              value={addName}
              onChange={(e) => setAddName(e.target.value)}
            />
            {errors.name && <span className="text-red-500">{errors.name}</span>}
          </div>
          <div>
            <label for="phoneNumber" class="block form_label_color pb-4">
              Phone Number <span className="aestrick_color">*</span>
            </label>
            <input
              disabled={isEditLocation}
              type="text"
              name="phoneNumber"
              className=" border_color border text-sm rounded-lg block w-full p-2.5 h-12"
              required
              // placeholder="Please enter Phone number"
              value={addPhoneNumber}
              onChange={(e) => setAddPhoneNumber(e.target.value)}
            />
            {errors.phoneNumber && (
              <span className="text-red-500">{errors.phoneNumber}</span>
            )}
          </div>
          <div className="w-full relative">
            <label className="block form_label_color pb-4">
              Time Zone <span className="aestrick_color">*</span>
            </label>

            {isEditLocation ? (
              <input
                disabled={isEditLocation}
                value={selectedTimeZoneName}
                type="text"
                name=""
                className=" border_color border text-sm rounded-lg block w-full p-2.5 h-12"
              />
            ) : (
              <select
                id="timezone"
                name="timezone"
                disabled={isEditLocation}
                value={selectedTimeZoneName}
                className="border_color border text-sm rounded-lg block w-full p-2.5 h-12 appearance-none"
                onChange={handleSelectTimeZoneChange}
              >
                <option value={""} selected disabled></option>
                {getTimezone?.map((tz) => (
                  <option key={tz.timezoneID} value={tz.displayName}>
                    {tz.displayName}
                  </option>
                ))}
              </select>
            )}
            <span className="absolute right-4 top-[65px] transform -translate-y-1/2 pointer-events-none">
              {isEditLocation ? (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="14"
                  height="8"
                  viewBox="0 0 14 8"
                  fill="none"
                >
                  <path
                    d="M12.9425 1.97314L8.0525 6.29891C7.475 6.80978 6.53 6.80978 5.9525 6.29891L1.0625 1.97314"
                    stroke="#87909E"
                    stroke-width="2"
                    stroke-miterlimit="10"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              ) : (
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M19.9201 8.94995L13.4001 15.47C12.6301 16.24 11.3701 16.24 10.6001 15.47L4.08008 8.94995"
                    stroke="#245CEA"
                    strokeWidth="2"
                    stroke-miterlimit="10"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              )}
            </span>
          </div>

          <div>
            <label
              for="principalInvestigator"
              class="block form_label_color pb-4"
            >
              Principal Investigator <span className="aestrick_color">*</span>
            </label>
            <input
              type="text"
              disabled={isEditLocation}
              name="principalInvestigator"
              className=" border_color border text-sm rounded-lg block w-full p-2.5 h-12"
              required
              // placeholder="Principal Investigator"
              value={addPrincipalInvestigator}
              onChange={(e) => setAddPrincipalInvestigator(e.target.value)}
            />
            {errors.principalInvestigator && (
              <span className="text-red-500">
                {errors.principalInvestigator}
              </span>
            )}
          </div>

          <div>
            <label for="operatingHours" class="block form_label_color pb-4">
              Operating Hours <span className="aestrick_color">*</span>
            </label>
            <div className="flex relative">
              <input
                type="text"
                name="operatinghours"
                className="border_color border text-sm rounded-lg block w-full p-2.5 h-12"
                required
                disabled={isEditLocation}
                value={inputResponse && inputResponse}
                onClick={addOperatingHours}
              />
              <span
                onClick={addOperatingHours}
                className="absolute right-[20px] top-3"
              >
                <IconTimer isEditLocation={isEditLocation} />
              </span>
            </div>
            {errors.operatingHours && (
              <span className="text-red-500">{errors.operatingHours}</span>
            )}
          </div>

          <div className="w-full">
            <label for="address" class="block form_label_color pb-4">
              Address <span className="aestrick_color">*</span>
            </label>
            <input
              type="text"
              name="address"
              className=" border_color border text-sm rounded-lg block w-full p-2.5 h-12"
              required
              disabled={isEditLocation}
              // placeholder="Please enter Address"
              value={addAddress}
              onChange={(e) => setAddAddress(e.target.value)}
            />
            {errors.address && (
              <span className="text-red-500">{errors.address}</span>
            )}
          </div>
          <div className="w-full relative">
            <label className="block form_label_color pb-4">
              Country/Region <span className="aestrick_color">*</span>
            </label>
            {isEditLocation ? (
              <input
                disabled={isEditLocation}
                value={selectCountry}
                type="text"
                name=""
                className=" border_color border text-sm rounded-lg block w-full p-2.5 h-12"
              />
            ) : (
              <select
                id="countyr"
                name="country"
                disabled={isEditLocation}
                value={selectCountry}
                className=" border_color border text-base rounded-lg block w-full p-2.5 h-12 appearance-none"
                onChange={handleSelectCountryChange}
              >
                <option value={""} selected disabled></option>
                {countryData?.map((tz) => (
                  <option key={tz.countryID} value={tz.countryName}>
                    {tz.countryName}
                  </option>
                ))}
              </select>
            )}
            <span className="absolute right-4 top-[65px] transform -translate-y-1/2 pointer-events-none">
              {isEditLocation ? (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="14"
                  height="8"
                  viewBox="0 0 14 8"
                  fill="none"
                >
                  <path
                    d="M12.9425 1.97314L8.0525 6.29891C7.475 6.80978 6.53 6.80978 5.9525 6.29891L1.0625 1.97314"
                    stroke="#87909E"
                    stroke-width="2"
                    stroke-miterlimit="10"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              ) : (
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M19.9201 8.94995L13.4001 15.47C12.6301 16.24 11.3701 16.24 10.6001 15.47L4.08008 8.94995"
                    stroke="#245CEA"
                    strokeWidth="2"
                    stroke-miterlimit="10"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              )}
            </span>
          </div>
          <div className="w-full relative">
            <label className="block form_label_color pb-4">
              State <span className="aestrick_color">*</span>
            </label>

            {isEditLocation ? (
              <input
                disabled={isEditLocation}
                value={selectStateName}
                type="text"
                name=""
                className=" border_color border text-sm rounded-lg block w-full p-2.5 h-12"
              />
            ) : (
              <select
                id="state"
                name="state"
                disabled={isEditLocation}
                value={selectStateName}
                className=" border_color border text-base rounded-lg block w-full p-2.5 h-12 appearance-none"
                onChange={handleSelectStateChange}
              >
                <option value={""} selected></option>
                {stateList?.map((tz) => (
                  <option key={tz.stateID} value={tz.stateName}>
                    {tz.stateName}
                  </option>
                ))}
              </select>
            )}
            <span className="absolute right-4 top-[65px] transform -translate-y-1/2 pointer-events-none">
              {isEditLocation ? (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="14"
                  height="8"
                  viewBox="0 0 14 8"
                  fill="none"
                >
                  <path
                    d="M12.9425 1.97314L8.0525 6.29891C7.475 6.80978 6.53 6.80978 5.9525 6.29891L1.0625 1.97314"
                    stroke="#87909E"
                    stroke-width="2"
                    stroke-miterlimit="10"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              ) : (
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M19.9201 8.94995L13.4001 15.47C12.6301 16.24 11.3701 16.24 10.6001 15.47L4.08008 8.94995"
                    stroke="#245CEA"
                    strokeWidth="2"
                    stroke-miterlimit="10"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              )}
            </span>
          </div>
          <div>
            <label
              for="principalInvestigator"
              class="block form_label_color pb-4"
            >
              City <span className="aestrick_color">*</span>
            </label>
            <input
              type="text"
              name="principalInvestigator"
              className=" border_color border text-sm rounded-lg block w-full p-2.5 h-12"
              required
              disabled={isEditLocation}
              value={city}
              onChange={(e) => setCity(e.target.value)}
            />
            {errors.city && <span className="text-red-500">{errors.city}</span>}
          </div>
          <div>
            <label for="Zip Code" class="block form_label_color pb-4">
              Zip Code <span className="aestrick_color">*</span>
            </label>
            <input
              type="text"
              name="Zip Code"
              className=" border_color border text-sm rounded-lg block w-full p-2.5 h-12"
              required
              disabled={isEditLocation}
              value={postal}
              onChange={(e) => setPostal(e.target.value)}
            />
            {errors.postal && (
              <span className="text-red-500">{errors.postal}</span>
            )}
          </div>

          <div className="fixed shadow-[0_-4px_20px_0_rgba(0,0,0,0.25)] p-5 pl-[36px] bottom-0 w-full -ml-8 bg-white pl-8 flex gap-[20px]">
            <button
              className="btn-primary-base-bar primary_btn"
              onClick={
                isEditLocation
                  ? () => {
                      setIsEditLocation(false);
                    }
                  : handleEditClinic
              }
            >
              {isEditLocation ? "Edit" : "Update"}
            </button>
            <BackButton
              editLocation={true}
              onClick={() => {
                setIsViewLocation(false);
              }}
            />
          </div>
        </div>
      </div>

      {/* popup for operating hours */}
      {isOpen && (
        <div className="fixed inset-0 bg-gray-800 bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg shadow-lg max-w-lg w-full p-2 relative">
            <button
              onClick={closePopup}
              className="absolute top-3 right-3 text-gray-500 hover:text-gray-700"
            >
              ✕
            </button>
            <OperatingHours
              getDataOp={getDataOp}
              setgetDataOp={setgetDataOp}
              isOpen={isOpen}
              setIsOpen={setIsOpen}
              setInputResponse={setInputResponse}
              inputResponse={inputResponse}
            />
          </div>
        </div>
      )}

      {/* Popup on submission */}
      {popup.show && (
        <div className="fixed inset-0 bg-gray-800 bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg shadow-lg max-w-lg w-full p-6 relative">
            <div className={`popup ${popup.isError ? "error" : "success"}`}>
              <p>{popup.message}</p>
              <button
                onClick={closePopup}
                className="absolute top-3 right-3 text-gray-500 hover:text-gray-700"
              >
                ✕
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default EditClinic;
